<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('电池数据查询.电池数据分析') }}</span>
              <div style="flex:1;text-align: right;">
                <quickQuery :isDownload="false" @handleQuery="onQuery" @quickQuery="onQuery" 
                    style="text-align: right" :isNow="true" />
            </div>
         
        </div>
        <el-divider></el-divider>
        <div class="page_container">

            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <!--每日充电次数分布-->
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeCountChart"></div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeDurationChart"></div>
                        </div>

                    </el-col>
                    <el-col :span="24">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeBeginTimeChart"></div>
                        </div>
                    </el-col>

                </el-row>
            </div>

        </div>
    </div>
</template>
<script>
import { queryVehicleBatteryDaily } from "@/http/vehicle";
import quickQuery from '../components/generalOrQuickQuery.vue'
// import * as echarts from 'echarts';
import { mapState } from "vuex";
export default {
    name: 'batteryStatistics',
    components: {
        quickQuery,
    },
    data() {
        return {
            loading: false,


            form: {
                queryDate: this.getTodayDate(),


            },
            chargeCountChart: undefined,
            chargeDurationChart: undefined,
            chargeBeginTimeChart: undefined,
            beginDate: undefined,
            endDate: undefined,
        }
    },
    computed: {
        ...mapState({
            //   opened: state => state.app.sidebar.opened,
            selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
            size: (state) => state.app.size,
        }),
    },
    methods: {

        getTodayDate() {
            //格式化为yyyy-MM-dd

            return [this.moment(new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'), this.moment(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD')]

        },

        onQuery(val) {
            //根据不同的tab查询不同的数据
            this.beginDate = val.beginDate;
            this.endDate = val.endDate;
            this.queryChartData();
        },

        queryChartData() {
           
            if (this.selectedVehicles.length == 0) {
                this.$message.warning(this.$t("vehicletrack.selectvehicle"));
                return;
            }
            if (this.selectedVehicles.length > 1) {
                this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
                return;
            }
            // console.log(this.selectedVehicles[0]);
            if (!this.beginDate || !this.endDate) {
                this.$message.error(this.$t("time.selectQueryTime"));
                return;
            }
            var vin = this.selectedVehicles[0].vincode
            //车辆
            this.loading = true;
            queryVehicleBatteryDaily({
                "vin": vin,
                "startDate": this.beginDate,// "2025-06-24",
                "endDate": this.endDate 
            }).then(res => {
                this.loading = false;
                console.log(res);
                var dates = [];
                var kSocData = [];
                var kTempData = [];
                var kVoltageData = [];

                res.data.forEach(item => {
                    dates.push(item.TheDate);
                    kSocData.push([
                        item.MinSOC,
                        item.MaxSOC,
                        item.MinSOC,
                        item.MaxSOC
                    ]);
                    kTempData.push([
                        item.Min_MinTemp,
                        item.Max_MaxTemp,
                        item.Min_MinTemp,
                        item.Max_MaxTemp,
                    ])

                    kVoltageData.push([
                        item.MinTotalVoltage,
                        item.MaxTotalVoltage,
                        item.MinTotalVoltage,
                        item.MaxTotalVoltage,
                    ])

                })
                // console.log(kSocData)
                var option_1 = {
                    xAxis: {
                        type: 'category',
                        data: dates,
                    },
                    series: [
                        {
                            data: kSocData,
                        }
                    ]
                };
                this.chargeCountChart.setOption(option_1);
                var option_2 = {
                    xAxis: {
                        type: 'category',
                        data: dates,
                    },
                    series: [
                        {
                            data: kTempData,
                        }
                    ]
                };
                this.chargeDurationChart.setOption(option_2);

                var option_3 = {
                    xAxis: {
                        type: 'category',
                        data: dates,
                    },
                    series: [
                        {
                            data: kVoltageData,
                        }
                    ]
                };
                this.chargeBeginTimeChart.setOption(option_3);
                this.loading = false;
                // this.tableData = res.data;
                // this.total = res.recordsTotal;
            })

        },

        initChart() {
            // 基于准备好的 DOM，初始化 ECharts 实例
            this.initChargeCountChart();
            this.initChargeDurationChart();
            this.initChargeBeginTimeChart();

        },
        getDefaultOption(title, formatter, yAxis_name, series_name) {
            return {
                title: {
                    text: title,
                    left: 'left'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    formatter: formatter
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    // boundaryGap: false,
                    axisLine: { onZero: true },
                    splitLine: { show: true },

                },
                yAxis: {
                    name: yAxis_name,
                    type: 'value',
                    scale: true,
                    min: function (value) {

                        return Math.floor(value.min * 0.9);
                    },
                    max: function (value) {
                        return Math.ceil(value.max * 1.1);
                    },
                    splitArea: {
                        show: true
                    }
                },
                series: [
                    {
                        name: series_name,
                        type: 'candlestick', // K线图类型
                        data: [],
                        barWidth: 15,
                        itemStyle: {
                            color: '#2A7AFF', // 上涨颜色
                            color0: '#2A7AFF', // 下跌颜色
                            borderColor: '#2A7AFF',
                            borderColor0: '#2A7AFF'
                        },
                        large: true,
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + '%';
                            }
                        }
                    }
                ]
            };
        },
        initChargeBeginTimeChart() {
            //充电时长分布
            this.chargeBeginTimeChart = echarts.init(document.getElementById('chargeBeginTimeChart'));
            const 电压 = this.$t("电池数据查询.电压");
            const option = this.getDefaultOption(this.$t("电池数据查询.整车电压"), (params) => {
                const param = params[0];

                const 整车最低电压 = this.$t("电池数据查询.整车最低电压");
                const 整车最高电压 = this.$t("电池数据查询.整车最高电压");

                return `
              <div style="font-weight: bold;">${param.name}</div>            
              <div>${整车最高电压}: ${param.data[2]} V</div>
              <div>${整车最低电压}: ${param.data[1]} V</div>
           
            `;
            }, 电压 + '(V)', 电压);

            // 使用配置项渲染图表
            this.chargeBeginTimeChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeBeginTimeChart.resize();
            });
        },
        initChargeDurationChart() {
            //充电时长分布
            this.chargeDurationChart = echarts.init(document.getElementById('chargeDurationChart'));
            const 温度 = this.$t("电池数据查询.温度");

            const option = this.getDefaultOption(this.$t("电池数据查询.电池温度"), (params) => {
                const param = params[0];

                const 单体电池最低温度 = this.$t("电池数据查询.单体电池最低温度");
                const 单体电池最高温度 = this.$t("电池数据查询.单体电池最高温度");
                return `
              <div style="font-weight: bold;">${param.name}</div>
                <div>${单体电池最高温度}: ${param.data[2]} ℃</div>
              <div>${单体电池最低温度}: ${param.data[1]} ℃</div>
            
           
            `;
            }, 温度 + '(℃)', 温度);


            // 使用配置项渲染图表
            this.chargeDurationChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeDurationChart.resize();
            });
        },
        initChargeCountChart() {
            //充电次数分布
            this.chargeCountChart = echarts.init(document.getElementById('chargeCountChart'));

            const 百分比 = this.$t("电池数据查询.百分比");
            const option = this.getDefaultOption(this.$t("电池数据查询.电池SOC"), (params) => {
                const param = params[0];


                const 电池SOC最小值 = this.$t("电池数据查询.电池SOC最小值");
                const 电池SOC最大值 = this.$t("电池数据查询.电池SOC最大值");

                return `
              <div style="font-weight: bold;">${param.name}</div>
               <div>${电池SOC最大值}: ${param.data[2]} %</div>
              <div>${电池SOC最小值}: ${param.data[1]} %</div>
             
           
            `;
            }, 百分比 + '(%)', 'SOC');



            // 使用配置项渲染图表
            this.chargeCountChart.setOption(option);

            // 监听窗口resize事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeCountChart.resize();
            });
        },

        // 生成K线模拟数据

    },
    mounted() {
        this.initChart();
        // this.queryChartData();

    }
}
</script>
<style scoped>
.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D9E4F8;

    margin-bottom: 20px;
}

.chart-container-chart {
    width: 100%;
    height: 380px;
}
</style>